export type TeamCalendarOptions = 'Humaniz' | 'Calendly';
export type TeamStatus = 'Active' | 'Inactive';
export type EventDuration = '30_minutes' | '15_minutes' | '45_minutes' | '60_minutes';
export type EventLocation = 'phone_call' | 'humaniz_conferencing' | 'standard_conferencing' | 'physical_location';
export type JobRefreshReviewStrategy = 'manual_no_ai' | 'manual_approve_ai' | 'auto_approve_ai';
export type RecruitingJobType = 'real_estate_agent' | 'loan_officer';
export type PipelineReviewStatus = 'not_configured' | 'active' | 'paused';

export type TeamEntity = {
  active_customer: boolean;
  allow_qualified_candidates_to_schedule_immediately: boolean;
  api_key: string | null;
  bulk_messaging_enabled: boolean;
  calendar_option: TeamCalendarOptions;
  calendly_api_active: boolean | null;
  calendly_api_error: string | null;
  calendly_api_token: string | null;
  calendly_link: string | null;
  calendly_link_followup: string | null;
  company: string | null;
  created_at: string;
  disqualified_rejection_email: string;
  ein_number: string | null;
  email_reply_to: string | null;
  esigner_user_id: number | null;
  headshot: string | null;
  ica_template_id: string | null;
  id: number;
  initial_referral_message: string;
  interview_event_address: string | null;
  interview_event_conferencing: boolean;
  interview_event_description: string;
  interview_event_duration: EventDuration;
  interview_event_location: EventLocation;
  interview_event_name: string;
  interview_user_id: number | null;
  job_refresh_review_strategy: JobRefreshReviewStrategy;
  legal_city: string | null;
  legal_company_name: string | null;
  legal_contact_email: string | null;
  legal_contact_name: string | null;
  legal_contact_phone_number: string | null;
  legal_contact_title: string | null;
  legal_country: string | null;
  legal_postal_code: string | null;
  legal_state: string | null;
  legal_street: string | null;
  logo: string | null;
  notify_new_teammate_referral: boolean;
  phone_screen_event_address: string | null;
  phone_screen_event_conferencing: boolean;
  phone_screen_event_description: string;
  phone_screen_event_duration: EventDuration;
  phone_screen_event_location: EventLocation;
  phone_screen_event_name: string;
  phone_screen_user_id: number;
  pipeline_review_event_address: string | null;
  pipeline_review_event_description: string;
  pipeline_review_event_duration: EventDuration;
  pipeline_review_event_location: EventLocation;
  pipeline_review_event_name: string;
  pipeline_review_status: PipelineReviewStatus;
  setup_progress: number;
  slug: string | null;
  status: TeamStatus | null;
  stripe_customer_id: string | null;
  stripe_plan: string | null;
  stripe_plan_id: string | null;
  stripe_plan_interval: string | null;
  stripe_total_mrr: number | null;
  stripe_total_spend: number | null;
  updated_at: string;
  use_job_refresh_workflow: boolean;
  website: string | null;
  recruiting_job_type: RecruitingJobType;
  zip_recruiter_conversion_tracking_id: string | null;
};

export const emptyTeamEntity: TeamEntity = {
  active_customer: false,
  allow_qualified_candidates_to_schedule_immediately: false,
  api_key: null,
  bulk_messaging_enabled: false,
  calendar_option: 'Humaniz',
  calendly_api_active: null,
  calendly_api_error: null,
  calendly_api_token: null,
  calendly_link: null,
  calendly_link_followup: null,
  company: null,
  created_at: '',
  disqualified_rejection_email: '',
  ein_number: null,
  email_reply_to: null,
  esigner_user_id: null,
  headshot: null,
  ica_template_id: null,
  id: 0,
  initial_referral_message: '',
  interview_event_address: null,
  interview_event_conferencing: false,
  interview_event_description: '',
  interview_event_duration: '30_minutes',
  interview_event_location: 'phone_call',
  interview_event_name: '',
  interview_user_id: null,
  job_refresh_review_strategy: 'manual_no_ai',
  legal_city: null,
  legal_company_name: null,
  legal_contact_email: null,
  legal_contact_name: null,
  legal_contact_phone_number: null,
  legal_contact_title: null,
  legal_country: null,
  legal_postal_code: null,
  legal_state: null,
  legal_street: null,
  logo: null,
  notify_new_teammate_referral: false,
  phone_screen_event_address: null,
  phone_screen_event_conferencing: false,
  phone_screen_event_description: '',
  phone_screen_event_duration: '30_minutes',
  phone_screen_event_location: 'phone_call',
  phone_screen_event_name: '',
  phone_screen_user_id: 0,
  pipeline_review_event_address: null,
  pipeline_review_event_description: '',
  pipeline_review_event_duration: '30_minutes',
  pipeline_review_event_location: 'phone_call',
  pipeline_review_event_name: '',
  pipeline_review_status: 'not_configured',
  setup_progress: 0,
  slug: null,
  status: null,
  stripe_customer_id: null,
  stripe_plan: null,
  stripe_plan_id: null,
  stripe_plan_interval: null,
  stripe_total_mrr: null,
  stripe_total_spend: null,
  updated_at: '',
  use_job_refresh_workflow: false,
  website: null,
  recruiting_job_type: 'real_estate_agent',
  zip_recruiter_conversion_tracking_id: null,
};
